import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { User } from 'firebase/auth';
import { auth, db } from '../Config/firebase';

import { getDoc, doc } from "firebase/firestore";

interface AuthContextType {
  currentUser: User | null;
  userRole: string | null;
  loading: boolean;
}

// Creating a context with a default value
const AuthContext = createContext<AuthContextType>({ currentUser: null, userRole: null, loading: true });

export const useAuth = () => useContext(AuthContext);

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const [userRole, setUserRole] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);


  const loadUserRole = async (user: User | null) => {
    // get current user role
    if (user) {

        // User is signed in, now fetch their role from the token
        user.getIdTokenResult()
        .then((idTokenResult) => {
          const role: string | null = idTokenResult.claims.role as string | null;  // Explicitly cast and handle potential undefined
          if (role) {
            console.log(`The current user's role is: ${role}`);
            setUserRole(role);
          } else {
            // No role assigned, or it's not set up correctly
            console.log("No role assigned to this user.");
            setUserRole(null);
          }
        })
        .catch((error) => {
          console.error("Error retrieving user data: ", error);
          setUserRole(null);
        });
        
        // // User is signed in, now fetch their role
        // const userDocRef = doc(db, "users", user.uid);
        // const userDoc = await getDoc(userDocRef);
        
        // if (userDoc.exists()) {
        //     const userData = userDoc.data();
        //     console.log(`The current user's role is: ${userData.role}`);
        //     // You can return the role here or do other logic based on the role
        //     setUserRole(userData.role);
        // }
        // else
        // {
        //     setUserRole(null);
        // }
    } else {
        setUserRole(null);
    }
    setLoading(false);
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user: User | null) => {
      setCurrentUser(user);
      loadUserRole(user);
    });

    // Cleanup subscription on unmount
    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    userRole,
    loading,
  };

  return <AuthContext.Provider value={value}>{!loading && children}</AuthContext.Provider>;
};
